import { AutomotiveEntityType } from '@/types';
import AxiosConfiguration from '@/classes/AxiosConfiguration';

const DocumentToStoreApiUrl = 'automotive/documentToStore/';

export const AutomotiveDocumentToStoreService = {
  async getNextEntityIdAsync(entityTypeId: AutomotiveEntityType): Promise<number> {
    const url = `${DocumentToStoreApiUrl}nextEntityId/${entityTypeId}`;
    const response = await AxiosConfiguration.axiosWithoutNotification.post(url);
    return response.data;
  }
};
